// extracted by mini-css-extract-plugin
export default {"wrap":"Hs-z","fullWidth":"Is-z","items":"Js-z","featureCss":"Ks-z","disabled":"Ls-z","imgCss":"Ms-z"};